import { cn } from "@lib/cn";
import { useState } from "react";
import type { IMediaFile } from "@/shared/types";
import { MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS } from "../../../constants";

interface IProps {
  fileData: IMediaFile;
  isSelected?: boolean;
}
export const MediaLibFileVideo = ({ fileData, isSelected }: IProps) => {
  const [isLoading, setIsLoading] = useState(true);

  let metaAspectRatio: number | undefined;
  if (
    fileData.metadata &&
    fileData.metadata.width &&
    fileData.metadata.height
  ) {
    metaAspectRatio = fileData.metadata.height / fileData.metadata.width;
  }

  return (
    <div
      className={cn("tw-relative tw-rounded tw-bg-blue-50", {
        "tw-animate-skeleton-loading": isLoading && !metaAspectRatio,
      })}
      style={{
        minHeight:
          isLoading && !metaAspectRatio
            ? MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS[0][0]
            : undefined,
      }}
    >
      <div
        style={{
          paddingTop: metaAspectRatio ? `${metaAspectRatio * 100}%` : undefined,
        }}
      >
        <video
          key={fileData._id}
          onLoadStart={() => {
            setIsLoading(true);
          }}
          onLoadedData={() => {
            setIsLoading(false);
          }}
          onMouseEnter={async (e) => {
            try {
              await e.currentTarget.play();
            } catch (e) {}
          }}
          onMouseLeave={(e) => {
            e.currentTarget.pause();
          }}
          style={{
            minHeight: isLoading
              ? MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS[0][0]
              : undefined,
          }}
          className={cn({
            "tw-absolute tw-left-0 tw-top-0": !!metaAspectRatio,
            "tw-size-full tw-cursor-pointer tw-rounded tw-bg-blue-50 tw-object-cover": true,
            "tw-opacity-0 tw-outline-none": isLoading,
            "tw-outline tw-outline-1 -tw-outline-offset-1 tw-transition-[outline-color] hover:tw-outline-offset-1 hover:tw-outline-primary":
              !isLoading,
            "tw-outline-offset-1 tw-outline-primary": !!isSelected,
            "tw-outline-blue/20": !isSelected,
          })}
          preload="metadata"
          muted
          playsInline
          loop
        >
          <Source url={fileData.url} />
        </video>
      </div>
    </div>
  );
};

const Source = ({ url }: { url: string }) => {
  if (url.endsWith(".webm")) {
    const mp4Url = url.replace(/\.webm$/, ".mp4");
    return (
      <>
        <source src={`${url}#t=0.1`} type="video/webm" />
        <source src={`${mp4Url}#t=0.1`} type="video/mp4" />
      </>
    );
  }
  return <source src={`${url}#t=0.1`} type="video/mp4" />;
};
